var map = {
	"./p1.jpg": 1778,
	"./p2.jpg": 7888,
	"./p3.jpg": 7550,
	"./p4.jpg": 2399,
	"./p5.jpg": 3268,
	"./p6.jpg": 1491,
	"./p7.jpg": 2779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3213;